﻿import {useContext} from "react";
import {GeocoderContext} from "../../context/geocoder-context";

export const useGeocoder = () => {
    return useContext(GeocoderContext)
}
